module.exports = __webpack_public_path__ + "static/media/ad.656c5b74.png";